import { useUserSector } from "@/core/hooks/useUserSector";
import { useAccountAccesses } from "@/hooks/useAccountAccesses";
import { useIsCompanyAdmin } from "@/hooks/useIsCompanyAdmin";

/**
 * Se o usuário é admin da empresa do SETOR ATIVO (admin de qualquer setor
 * dela, mesma regra do `verify-company-admin-access` do backend). Faturamento
 * é da empresa, não do setor: é esta a regra que abre a aba, não a
 * `ui:settings:view` do setor ativo.
 *
 * `isLoading` vale até os acessos chegarem E o setor ativo ser confirmado
 * como um deles (`isActiveSectorReady`): logo depois do login o setor ativo
 * ainda pode ser o do localStorage de outro usuário, e a empresa ativa sairia
 * `null` ("não admin") por um render. Quem decide um bloqueio espera por ele,
 * senão o admin veria o bloqueio piscar. Falha ao buscar os acessos encerra o
 * carregamento como "não admin" (falha fechada).
 */
export function useActiveCompanyAdmin() {
  const { activeSectorId, isActiveSectorReady } = useUserSector();
  const accountAccessesQuery = useAccountAccesses();
  const accountAccesses = accountAccessesQuery.data ?? [];
  const activeCompanyId =
    accountAccesses.find(
      (access) => access.sector.documentId === activeSectorId
    )?.company.documentId ?? null;
  const isCompanyAdmin = useIsCompanyAdmin(activeCompanyId);

  const isWaitingActiveSector =
    accountAccessesQuery.isSuccess &&
    accountAccesses.length > 0 &&
    !isActiveSectorReady;

  const isLoading = accountAccessesQuery.isLoading || isWaitingActiveSector;

  return {
    isCompanyAdmin,
    isLoading,
    // Empresa do setor ativo, só depois de confirmada (no meio do carregamento
    // ela pode ser a do setor de outro usuário). SA-1433: aba Retenção de dados.
    activeCompanyId: isLoading ? null : activeCompanyId,
  };
}
